var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-3"},[_c('a',{staticClass:"card-link text-decoration-none",attrs:{"href":"#","title":"Star"}},[_c('i',{staticClass:"fa fa-star-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.repo.stargazers_count))])])}
var staticRenderFns = []

export { render, staticRenderFns }